import { Injectable } from '@angular/core';
import { INews } from '@core/interfaces/news.interface';

export const STORAGE_KEY = 'dashboard_read_news_ids';

@Injectable({
  providedIn: 'root',
})
export class NotificationsButtonService {
  public getReadNewsIds(): string[] {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  public markNewsAsRead(newsItems: INews[]): void {
    const readNewsIds = this.getReadNewsIds();
    const newsIds = newsItems.map((item) => item.id ?? '');
    const idsSet = new Set([...readNewsIds, ...newsIds]);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(idsSet)));
  }
}
